import { classNameMerger } from '@breetometer/utils';
import { ChevronDown } from 'BreetAssets';

import type { DropdownControlProps } from '../../Dropdown.helpers';
import { DefaultInputValue } from '../input-value/Default';

export const DefaultDropDownControl = ({
	selectedItem,
	buttonRef,
	handleVisibility,
	visible,
	iconAs,
	readOnly,
	readOnlySeparator,
	isLabel,
	CustomItemSelectedProps,
	disabled,
}: DropdownControlProps) => {
	const openClass = visible ? ' open' : '';
	const validClass = selectedItem?.value ? ' valid' : '';
	const labelClass = !isLabel ? ' no-label' : '';

	const chevronClass = `dropdown_content_control_chevron svg-dark toggleicon${openClass}`;
	const buttonClass = `dropdown_content_control${openClass}${validClass}${labelClass}`;

	return (
		<button
			onClick={readOnly || disabled ? undefined : handleVisibility}
			className={buttonClass}
			ref={buttonRef}
			type='button'
		>
			{!CustomItemSelectedProps ? (
				<>
					{!!selectedItem?.icon && (
						<span className='dropdown_content_control_flag'>
							<DefaultInputValue
								icon={selectedItem.icon}
								iconAs={iconAs}
							/>
						</span>
					)}
					{!!selectedItem?.value && (
						<span
							className={classNameMerger('dropdown_content_control_code', disabled ? 'color-primary-200' : 'color-neutral-50')}
						>
							{selectedItem.value}
						</span>
					)}
					{!readOnly && <ChevronDown className={chevronClass} />}
					{readOnly && readOnlySeparator && <span className='dropdown_content_control_separator bg-dark-navy' />}
				</>
			) : (
				selectedItem && <CustomItemSelectedProps item={selectedItem} />
			)}
		</button>
	);
};
